import { useTranslation } from "react-i18next";
import MarketingShell, { LegalSection } from "@/components/MarketingShell";

export default function Refund() {
  const { t } = useTranslation();
  return (
    <MarketingShell
      eyebrow={t("legal.refund.eyebrow")}
      title={t("legal.refund.title")}
      updated={t("legal.refund.updated")}
    >
      <p className="text-lg text-foreground">{t("legal.refund.intro")}</p>

      <LegalSection heading={t("legal.refund.s1h")}><p>{t("legal.refund.s1b")}</p></LegalSection>
      <LegalSection heading={t("legal.refund.s2h")}><p>{t("legal.refund.s2b")}</p></LegalSection>
      <LegalSection heading={t("legal.refund.s3h")}><p>{t("legal.refund.s3b")}</p></LegalSection>
      <LegalSection heading={t("legal.refund.s4h")}><p>{t("legal.refund.s4b")}</p></LegalSection>
      <LegalSection heading={t("legal.refund.s5h")}><p>{t("legal.refund.s5b")}</p></LegalSection>
      <LegalSection heading={t("legal.refund.s6h")}>
        <p>
          {t("legal.refund.s6b")}{" "}
          <a href="mailto:info@aiboosters.net" className="text-intl underline underline-offset-4">info@aiboosters.net</a>.
        </p>
        <p className="font-mono text-xs text-muted-foreground mt-2">{t("legal.refund.company")}</p>
      </LegalSection>
    </MarketingShell>
  );
}
